import { render, staticRenderFns } from "./SkuConfiguration.vue?vue&type=template&id=280e5fc7&scoped=true&"
import script from "./SkuConfiguration.vue?vue&type=script&lang=js&"
export * from "./SkuConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280e5fc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280e5fc7')) {
      api.createRecord('280e5fc7', component.options)
    } else {
      api.reload('280e5fc7', component.options)
    }
    module.hot.accept("./SkuConfiguration.vue?vue&type=template&id=280e5fc7&scoped=true&", function () {
      api.rerender('280e5fc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product/components/SkuConfiguration.vue"
export default component.exports